// extracted by mini-css-extract-plugin
export default {"Modal":"modal_Modal__kVxdJ"};